import { LegalUtopiaGroupIcon } from 'assets/icons/LegalUtopiaGroupIcon'

interface LogoWithTitleProps {
  title: string
}

export const LogoWithTitle = ({ title }: LogoWithTitleProps) => {
  return (
    <div className='flex space-x-2 items-center 3xl:space-x-4'>
      <LegalUtopiaGroupIcon className='h-8 w-8 lg:h-12 lg:w-12 3xl:h-16 3xl:w-16' />
      <span className='text-lg font-medium text-[#001A3D] lg:text-[32px] 3xl:text-4xl'>
        {title}
      </span>
    </div>
  )
}
